import React from 'react';
import { MoonLoader } from 'react-spinners';

type LengthType = number | string;

interface SpinnerProps {
    size?: LengthType;
    margin?: LengthType;
    color?: string;
    loading?: boolean;
    className?: string;
    speedMultiplier?: number;
}

const SmallSpinner: React.FC<SpinnerProps> = ({
    size = 5,
    margin = 2,
    color = '#2970ff',
    loading = true,
    className,
    speedMultiplier = 1,
}) => {
    return (
        <MoonLoader
            size={10}
            color={color}
            loading={loading}
            speedMultiplier={speedMultiplier}
            className={className}
        />
    );
};

export default SmallSpinner;
